import { ERequestSubmitted, IRequest } from 'legacy/lut/classes/models/onboarding/IRequest'
import { RequestTypes } from 'legacy/lut/classes/models/onboarding/Onboarding'

import { IPaging, IPagingFromTo } from 'core-components/types'
import { TResponse } from 'core/classes/ws/WebSocketClient'
import { isInstanceOf } from 'core/utils/functions'
import settings from 'src/config/settings'

// TODO: Remove when deploy https://hpscoutso.spa.hpcloud.hp.com/page/kanban/issue/4920
export const isAppOwnerProduction = ['aws-hpscoutso-prod', 'aws-lut-prod'].includes(
  settings.appIdentifier.ownerId
)

export const isPortalRequest = (request: Pick<IRequest, 'Submitted' | 'Type'>) =>
  Boolean(
    request.Submitted &&
      request.Type &&
      [ERequestSubmitted.online, ERequestSubmitted.rcs].includes(request.Submitted) &&
      request.Type === RequestTypes.Contract
  )

export const isAppLut = () => settings.appIdentifier.id === 'lut'

export const convertToServerPaginationIfNot = (pagination: IPaging | IPagingFromTo): IPaging => {
  const canBeConverted = isInstanceOf<IPagingFromTo>(pagination, (o) => 'to' in o && 'from' in o)
  return canBeConverted
    ? {
        page: pagination.to / (pagination.to - pagination.from) - 1,
        pageSize: pagination.to - pagination.from,
      }
    : pagination
}

export const getErrorResponse = <T extends Record<string, any>>(
  errorMessage: string,
  data: T
): Required<TResponse<T>> => {
  return {
    status: 'error',
    data,
    message: errorMessage,
  }
}

const getUnit = (power: number) => {
  const units = {
    0: 'B',
    1: 'KB',
    2: 'MB',
    3: 'GB',
    4: 'TB',
  }

  return units[power]
}

export const getFileSize = (bytes: number) => {
  const ONE_KB_BYTES = 1024
  const power = Math.floor(Math.log(bytes) / Math.log(ONE_KB_BYTES))
  const unit = getUnit(power)
  const size = power === 0 ? bytes : (bytes / Math.pow(ONE_KB_BYTES, power)).toFixed(2)

  return `${size} ${unit}`
}
